export default __webpack_public_path__ + "images/N4.a0ad407.png";